import React, { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import {
  KivuI18nContext,
  localizedPath,
  PAGE_PORTAL_DASHBOARD,
  PORTAL_PREFIX,
  BRAND_COLOR,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

const NoStoreDetailFound: React.FC = () => {
  const { t } = useKivunovaTranslation();
  const navigate = useNavigate();
  const { language, defaultLang } = useContext(KivuI18nContext);

  return (
    <Box
      sx={{
        p: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "70vh",
        color: "black"
      }}
    >
      <Typography color="textPrimary" variant="h5" fontWeight="bold" mb={2}>
        {t("store-not-found", "Store not found")}
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {t(
          "store-not-found-description",
          "The store you're looking for doesn't exist or has been removed."
        )}
      </Typography>
      <Button
        variant="text"
        startIcon={<ArrowBackOutlinedIcon />}
        onClick={() =>
          navigate(
            localizedPath(
              `${PORTAL_PREFIX}${PAGE_PORTAL_DASHBOARD}`,
              language,
              defaultLang
            )
          )
        }
        style={{ color: BRAND_COLOR, textTransform: "none" }}
      >
        {t("back-home", "Back home")}
      </Button>
    </Box>
  );
};

export default NoStoreDetailFound;
